<template>
    <div class="binDrawMode">
        <div class="header">
            <h2 class="modeTitle">提现方式</h2>
            <p class="tips">平台提供以下提现方式，请绑定您真实的收款方式以确保资金安全。</p>
        </div>
        <CellGroup>
            <Cell v-if="wxSwitch === 'START'" :title="`微信 ${wx.accountName}`" value="换绑" is-link
                title-class="title-class" value-class="value-class" @click="bindWx">
                <img src="../../../../assets/images/ic_wechat.png" class="modeIcon" slot="icon" alt="">
            </Cell>
            <Cell v-if="zfbSwitch === 'START'" :title="`支付宝 ${zfb.accountName}`" value="换绑" is-link
                title-class="title-class" value-class="value-class" @click="bindZFB">
                <img src="../../../../assets/images/ic_alipay.png" class="modeIcon" slot="icon" alt="">
            </Cell>
        </CellGroup>
    </div>
</template>

<script>
/*
* 提现方式
* */
import { Cell, CellGroup } from 'vant';
import { getTransferAccount, getCodeByAuthUrl, getWeChatInfoByWeb, getDrawConfig } from "../../../../api/withdraw";
import qs from 'qs'

export default {
    name: "DrawMode",
    components: {
        Cell,
        CellGroup
    },
    data() {
        return {
            wx: { "account": "", "accountName": "", id: "" },
            zfb: { "account": "", "accountName": "", id: "" },
            wxSwitch: 'CLOSE',     // 根据后台配置，是否开启微信提现通道
            zfbSwitch: 'CLOSE',     // 根据后台配置，是否开启支付宝提现通道
           
        }
    },
    created() {
        getDrawConfig().then(res => {
            let { wxSwitch, zfbSwitch } = res;
            this.wxSwitch = wxSwitch;
            this.zfbSwitch = zfbSwitch;
        });

        let code = this.$route.query.code;
        new Promise((resolve, reject) => {
            if (code) {
                getWeChatInfoByWeb(code).then(_ => {
                    resolve()
                });
            } else {
                resolve()
            }
        }).then(_ => {
            this.getAccount();
        })
    },
    methods: {
        getAccount() {
            getTransferAccount().then(res => {
                if (res.length > 0) {
                    res.map(obj => {
                        const singleData = { "accountName": obj.accountName, "account": obj.account, "id": obj.id };
                        // if (obj.type === "ZFB") {
                        //     this.zfb = singleData;
                        // }
                        if (obj.type === "WX") {
                            this.wx = singleData;
                           
                        }
                    })
                }
            })
        },
        bindZFB() {
            this.toPage(`/bindZFB?${qs.stringify(this.zfb)}`);
        },
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;    // 在微信浏览器内
            } else {
                return false;   // 不再微信浏览器内
            }
        },
        bindWx() {
            if (this.isWeiXin()) {
                getCodeByAuthUrl().then(res => {
                    window.location.href = res;

                })
            } else {
                this.toast({
                    text: '请在微信环境进行换绑!',
                    icon: 'warning'
                })
            }
        },

    }
}
</script>

<style lang='less' scoped>
.binDrawMode {
    min-height: 100vh;
    background-color: #f8f8f8;

    .header {
        padding: 4.1vw 4.5vw;

        .modeTitle {
            margin-bottom: 1.3vw;
            font-size: 4vw;
            color: #333333;
        }

        .tips {
            font-size: 3.2vw;
            color: #979797;
        }
    }

    .modeIcon {
        width: 6.4vw;
        height: 6.4vw;
        margin-right: 4.7vw;
    }

    .value-class {
        font-size: 3.2vw;
        color: #d2d2d2;
    }

    .title-class {
        font-size: 3.5vw;
        color: #333333;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/mine/withdraw/drawMode/DrawMode.vue